import Vector from './component';
import { lineTool } from '../shared/line';

export const tool = lineTool('vector', Vector);
